import React from 'react';
import AppBar from '@material-ui/core/AppBar';
import Toolbar from '@material-ui/core/Toolbar';
import Grid from '@material-ui/core/Grid';

import ErrorBoundary from './ErrorBoundary';
import NotificationsHelpDialog from './NotificationsHelpDialog';
import { getPermission, requestPermission } from '../utils/desktopNotifications';
import PopupBlockedDialog from './PopupBlockedDialog';
import { closeNamedWindow } from '../utils/popupWindows';
import UserInfo from './UserInfo';
import Profile from './Profile';
import Bulletin from './Bulletin';
//import BulletinNew from './BulletinNew';
import ManageUser from './ManageUser';
import ManageGroup from './ManageGroup';
import OnCallScheduleList from './OnCallScheduleList';
import Announcement from './Announcement';
import AnnouncementMessage from './AnnouncementMessage';
import QuoteManager from './QuoteManager';

import { logoutUser } from '../actions/logout_actions';
import getProfileFetch from '../actions/profile_actions';
import windowActions from '../actions/window_actions';
import userActions from '../actions/user_actions';

import { connect } from 'react-redux';
import Menu from '@material-ui/core/Menu';
import MenuItem from '@material-ui/core/MenuItem';
import Tooltip from '@material-ui/core/Tooltip';
import MenuIcon from '@material-ui/icons/Menu';
import IconButton from '@material-ui/core/IconButton';
import NewWindow from 'react-new-window';
import { flashApp } from '../utils/flashNotification';
import { isOn } from '../utils/notificationPreferences';
import { dueSlot, latestSlot, isScheduleDay } from '../utils/bulletinSchedule';
import { showMessageNotification } from '../utils/desktopNotifications';
import PreferencesDialog from './PreferencesDialog';
import preferenceActions from '../actions/preference_actions';

export class UserHub extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      anchorEl: null,
      announcements: [],
      logoutClicked: false,
      profile: this.props.profile,
      showBulletin: false,
      showUserManager: false,
      showGroupManager: false,
      showQuoteManager: false,
      showMakeAnnouncement: false,
      popupsBlocked: false,
      notificationPermission: getPermission(),
      notificationsBlockedOpen: false,
      preferencesOpen: false,
      /**/
      features: {
        width: 800,
        height: 490,
        top: window.screenTop,
        left: window.screenLeft + 205 + 434 + 5, // window.innerWidth + 434 + 10, // some space + 10 // window is not 450 on test site
        screenX: window.screenX + 205 + 434 + 5, // window.innerWidth + 434 + 10, // some space + 10
        screenY: window.screenY
      },
      salesFeatures: {
        width: 1000,
        height: 700
      },
      userManagerfeatureSize: {
        width: 750, // 700,
        height: 675
      },
      groupManagerfeatureSize: {
        width: 590, // 700,
        height: 365
      },
      announcementfeatureSize: {
          width: 500,
          height: 335 //
      },
      announcementMessagefeatureSize: {
          width: 545,
          height: 80
      },
    };
  }

  componentDidMount() {
      this.subscribeToAnnouncements();
      // Checked against the wall clock rather than timed to the slot: a
      // multi-hour setTimeout is throttled in a background tab and lost
      // across sleep, and a check every 30s costs nothing.
      this.bulletinTimer = setInterval(() => this.checkBulletinSchedule(), 30000);
      this.checkBulletinSchedule();
  };

  componentDidUpdate() {
      this.subscribeToAnnouncements();
      // The login pop-up waits on the profile and the stored preferences,
      // which both arrive as prop updates after mount.
      this.checkBulletinSchedule();
  };

  componentWillUnmount() {
      clearInterval(this.bulletinTimer);
  };

  // The bulletin.autoOpen preference: open the bulletin once at login, then
  // at each slot in utils/bulletinSchedule. Signing in reloads the page, so
  // "the first check after mount" is login.
  checkBulletinSchedule = (now = new Date()) => {
      if (localStorage.getItem("token") === null || !this.props.profile || !this.props.profile.id) {
          return;
      }
      // Not before the preferences load - an empty map would read as the
      // default and pop the bulletin up for someone who turned it off.
      if (!this.props.preferencesLoaded) {
          return;
      }

      let fire;
      if (!this.bulletinStartupHandled) {
          this.bulletinStartupHandled = true;
          // Logging in at 9:10 shows the bulletin once, not again for 9:00.
          const current = latestSlot(now);
          this.lastBulletinSlot = current ? current.key : null;
          fire = isScheduleDay(now);
      } else {
          const slot = dueSlot(now, this.lastBulletinSlot);
          if (slot) {
              this.lastBulletinSlot = slot;
          }
          fire = slot !== null;
      }

      if (fire && isOn(this.props.preferences, 'bulletin', 'autoOpen')) {
          this.popUpBulletin();
      }
  };

  // Remounts the NewWindow, so one left open is closed and reopened in front
  // with fresh numbers. Used by the menu item and the schedule alike.
  popUpBulletin = () => {
      this.setState({ showBulletin: false }, () => { this.setState({ showBulletin: true }); });
  };

  // state.hub starts out as {} and is only replaced once App's
  // connection.start() resolves. This used to fire blind on a 5 second timer
  // and call hub.on regardless, so it threw "this.props.hub.on is not a
  // function" whenever the connection took longer than that, was never
  // attempted (no token, so App skips start()), or was refused because the
  // server was restarting. Bind when a real hub actually turns up instead,
  // and only once.
  subscribeToAnnouncements = () => {
      if (this.announcementsBound || localStorage.getItem("token") === null) {
          return;
      }

      const hub = this.props.hub;
      if (!hub || typeof hub.on !== 'function') {
          return;
      }

      this.announcementsBound = true;
      hub.on('NewAnnouncement', (announcement => {
          // slice, not splice: splice() with no arguments returns an empty array,
          // so every announcement replaced the list instead of joining it and
          // only the newest one was ever rendered.
          var newAnnouncements = this.state.announcements.slice();
          newAnnouncements.push(announcement.payload);
          this.setState({ 'announcements': newAnnouncements });
      }));
  };

  closeChatWindowLogout = () => {
    this.props.callbackFromParentLogout(this.state.logoutClicked);
  }

  handleClickMainMenu = (event) => {
      this.setState({ anchorEl: event.currentTarget }); // 

  };

  handleCloseMainMenu = () => {
    this.setState({ anchorEl: null });
  };

  handleClickLogout = (event) => {
      event.preventDefault();
      this.setState({ anchorEl: null });
      flashApp(this.props.preferences, 'flashstop');
      // Was an if testing all six for null and then re-opening each to close
      // it. closeNamedWindow does the null check per window.
      ['ChatBoxWindow', 'Bulletin', 'MakeAnnouncement', 'Announcement', 'UserManager', 'GroupManager']
          .forEach(name => closeNamedWindow(name));
      this.props.setChatDisplay(false);

      var updatedUser = { ...this.props.profile };
      updatedUser["status"] = "Done";
      updatedUser["inOffice"] = false;
      updatedUser["stamp"] = "validLogout";
      this.props.updateProfile(updatedUser);
      //this.props.updateLastSeen();
      localStorage.removeItem("token"); // Remove the token from localStorage
      this.props.logoutUser(); // Remove the user object from the Redux store
      setTimeout(() => window.location.reload(), 1000);
  };

  handleCloseMainMenuCallback = () => {
    this.setState({ anchorEl: null });
  };

  // This used to close and focus the open bulletin through
  // window.open('', 'BulletinWindow') - but the window is named 'Bulletin',
  // and window.open with a name nothing carries creates a blank window, so
  // clicking View Bulletin with the bulletin open left a stray one behind.
  // Remounting the NewWindow does the close-and-reopen by itself, and a
  // blocked pop-up is still reported through its ErrorBoundary.
  handleShowBulletin = () => {
      this.popUpBulletin();
  };

    // Every detached window here is a react-new-window pop-up, and that library
  // throws rather than reporting a blocked one - see components/ErrorBoundary.js.
  // An announcement arrives on a hub push, so without this an announcement
  // landing while pop-ups are blocked would white out the app with no warning.
  //
  // The closer puts the matching show* flag back down, so the boundary's
  // fallback is not rebuilt and retried on the next render.
  popupBlocked = (closer) => () => {
    this.setState({ popupsBlocked: true });
    if (typeof closer === 'function') {
      closer();
    }
  };

  handlePopupBlocked = () => {
    this.setState({ popupsBlocked: true });
  };

  // MUI v4 puts aria-hidden on #root from a ref callback during commit,
  // while its focus trap moves focus in a later useEffect. Chrome sees the
  // trigger still focused inside the subtree being hidden and refuses,
  // logging "Blocked aria-hidden on an element because its descendant
  // retained focus". Blurring here and restoring from onExited is the
  // pattern UserInfo already uses.
  handleOpenPreferences = (event) => {
      if (event && event.currentTarget && event.currentTarget.blur) {
          event.currentTarget.blur();
      }
      // anchorEl is the menu button. Keep it: the MenuItem that was clicked
      // unmounts with the menu, so it cannot be focused afterwards.
      this.preferencesTrigger = this.state.anchorEl;
      this.setState({ anchorEl: null, preferencesOpen: true, notificationPermission: getPermission() });
  };

  closePreferences = () => {
      this.setState({ preferencesOpen: false });
  };

  // Has to be onExited: anything earlier is overwritten by MUI's own
  // focus restore once the closing transition finishes.
  restoreFocusAfterPreferences = () => {
      if (this.preferencesTrigger && this.preferencesTrigger.focus) {
          this.preferencesTrigger.focus();
      }
  };

  savePreferences = (items) => this.props.savePreferences(items);

  // Asks for permission from this click. Firefox 72+ refuses a request
  // with no user gesture, and refuses silently.
  requestNotificationPermission = () => {
      requestPermission().then(result => {
          this.setState({ notificationPermission: result });
          // A denial is final - asking again resolves denied immediately and
          // shows the user nothing - so explain where the setting lives.
          if (result === 'denied') {
              this.setState({ notificationsBlockedOpen: true });
          }
      });
  };

  // Deliberately bypasses the neither-window-has-focus rule: the user is
  // looking at this panel, so the normal rule would suppress the very
  // thing they asked to see. This is the only path allowed to do that.
  handleTestNotification = () => {
      const prefs = this.props.preferences;
      // Sets the flag the way every other flashstart does. Without it the
      // page did not know the taskbar was flashing, and while flashstop was
      // gated on that flag nothing could stop a flash this button started.
      if (flashApp(prefs, 'flashstart')) {
          this.props.setIconFlash(true);
      }
      let shown = false;
      if (isOn(prefs, 'notifications', 'desktop')) {
          // Carries a sample body when previews are on. The whole point of
          // this button is to show what a toast looks like, and with the
          // preference on that now includes whether it carries the message.
          shown = showMessageNotification({
              senderName: 'TeamX (test)',
              senderId: 'test',
              body: isOn(prefs, 'notifications', 'preview')
                  ? 'This is where the message would appear.'
                  : undefined,
          }) !== null;
      }
      if (!shown && isOn(prefs, 'notifications', 'sound')) {
          new Audio('./light.mp3').play();
      }
  };

  dismissNotificationsHelp = () => {
    this.setState({ notificationsBlockedOpen: false });
  };

  dismissPopupNotice = () => {
    this.setState({ popupsBlocked: false });
  };

  // No closeNamedWindow here: it named 'BulletinWindow', so it opened a blank
  // window just to close it. Unmounting the NewWindow closes the real one.
  handleCloseBulletin = () => {
      this.setState({ showBulletin: false, anchorEl: null });

  };

  handleShowUserManager = () => {
    this.setState({ showUserManager: true });
  };

  handleCloseUserManager = () => {
    this.setState({ showUserManager: false, anchorEl: null });
  };

  handleShowGroupManager = () => {
    this.setState({ showGroupManager: true });
  };

  handleCloseGroupManager = () => {
    this.setState({ showGroupManager: false, anchorEl: null });
  };

  handleShowQuoteManager = () => {
    this.setState({ showQuoteManager: true });
  };

  handleCloseQuoteManager = () => {
    this.setState({ showQuoteManager: false, anchorEl: null });
  };

  handleShowMakeAnnouncement = () => {
    this.setState({ showMakeAnnouncement: true });
  };

  handleCloseMakeAnnouncement = () => {
    this.setState({ showMakeAnnouncement: false, anchorEl: null });
  };

  closeAnnouncement = (announcement) => () => {
    var newAnnouncements = [];
    for (var i = 0; i < this.state.announcements.length; i++) {
      if (this.state.announcements[i]['message'] === announcement['message']) {
        continue;
      }
      // [i], not the whole array. This only ever ran against a list of one
      // while the handler above was throwing the previous announcements away,
      // so pushing the array itself went unnoticed; with the list accumulating
      // it would nest arrays and break the render.
      newAnnouncements.push(this.state.announcements[i]);
    }
    this.setState({ 'announcements': newAnnouncements });
  };

  render() {
    const { anchorEl } = this.state;
    let onCallSchedule;
    let bulletin;
    let featureSize;
    let userManager;
    let groupManager;
    let announcement;
    let userManagerMenuItem;
    let groupManagerMenuItem;
    let quoteManager;
    let quoteManagerMenuItem;

    // prevents undefined error
    let userRoles = this.props.profile.roles || "";

    if (userRoles.includes("S")) {
      featureSize = this.state.salesFeatures;
    } else {
      featureSize = this.state.features;
    }

    // Always present. It used to be hidden once permission was granted and
    // hidden entirely where the API is missing, so it disappeared exactly
    // when it was working, and there was nowhere to see how TeamX notifies
    // you or to turn any of it off.
    const notificationsMenuItem =
        <MenuItem onClick={this.handleOpenPreferences} style={{ padding: '5px 10px', fontSize: '12px', minHeight: '25px' }}><div style={{ color: "white" }}>&bull;</div> Preferences</MenuItem>;

    if (this.state.showBulletin === true) {
      bulletin =
        <ErrorBoundary onError={this.popupBlocked(this.handleCloseBulletin)}>
          <NewWindow title={'Bulletin'} name={'Bulletin'} onUnload={this.handleCloseBulletin} onBlock={this.popupBlocked(this.handleCloseBulletin)} center='screen' features={featureSize}>
            <Bulletin profile={this.props.profile} />
          </NewWindow>
        </ErrorBoundary>;
    }

    if (userRoles.includes("A")) {
      userManagerMenuItem =
        <MenuItem onClick={this.handleShowUserManager} style={{ padding: '5px 10px', fontSize: '12px', minHeight: '25px' }}><div style={{ color: "white" }}>&bull;</div> User Manager</MenuItem>;
    }

    if (this.state.showUserManager === true) {
      userManager =
        <ErrorBoundary onError={this.popupBlocked(this.handleCloseUserManager)}>
          <NewWindow title={'User Manager'} name={'User Manager'} onUnload={this.handleCloseUserManager} onBlock={this.popupBlocked(this.handleCloseUserManager)} center='screen' features={this.state.userManagerfeatureSize}>
            <ManageUser />
          </NewWindow>
        </ErrorBoundary>;
    }

    if (userRoles.includes("A")) {
      groupManagerMenuItem =
        <MenuItem onClick={this.handleShowGroupManager} style={{ padding: '5px 10px', fontSize: '12px', minHeight: '25px' }}><div style={{ color: "white" }}>&bull;</div> Group Manager</MenuItem>;
    }

    if (this.state.showGroupManager === true) {
      groupManager =
        <ErrorBoundary onError={this.popupBlocked(this.handleCloseGroupManager)}>
          <NewWindow title={'Group Manager'} name={'Group Manager'} onUnload={this.handleCloseGroupManager} onBlock={this.popupBlocked(this.handleCloseGroupManager)} center='screen' features={this.state.groupManagerfeatureSize}>
            <ManageGroup />
          </NewWindow>
        </ErrorBoundary>;
    }

    if (userRoles.includes("A")) {
      quoteManagerMenuItem =
        <MenuItem onClick={this.handleShowQuoteManager} style={{ padding: '5px 10px', fontSize: '12px', minHeight: '25px' }}><div style={{ color: "white" }}>&bull;</div> Quote Manager</MenuItem>;
    }

    if (this.state.showQuoteManager === true) {
      quoteManager =
        <ErrorBoundary onError={this.popupBlocked(this.handleCloseQuoteManager)}>
          <NewWindow title={'Quote Manager'} name={'Quote Manager'} onUnload={this.handleCloseQuoteManager} onBlock={this.popupBlocked(this.handleCloseQuoteManager)} center='screen' features={this.state.userManagerfeatureSize}>
            <QuoteManager />
          </NewWindow>
        </ErrorBoundary>;
    }

    // Make Announcement (part of MenuItem)style={{ padding: '5px 10px', fontSize: '12px', minHeight: '25px' }} (inside MenuItem)<div style={{ color: "white" }}> &bull;</div>
    let announcementMenuItem = <MenuItem onClick={this.handleShowMakeAnnouncement} style={{ padding: '5px 10px', fontSize: '12px', minHeight: '25px' }}><div style={{ color: "white" }}>&bull;</div> Make Announcement</MenuItem>;
    if (this.state.showMakeAnnouncement === true) {
        announcement =
            <ErrorBoundary onError={this.popupBlocked(this.handleCloseMakeAnnouncement)}>
                <NewWindow name={'Make Announcement'} onUnload={this.handleCloseMakeAnnouncement} onBlock={this.popupBlocked(this.handleCloseMakeAnnouncement)} center='screen' features={this.state.announcementfeatureSize} title={'Make Announcement'}>
                    <Announcement />
                </NewWindow>
            </ErrorBoundary>;
    }

    // Announcement Message
    let announcements = [];
    for (var i = 0; i < this.state.announcements.length; i++) {
       
        announcements.push(
            <ErrorBoundary key={i} onError={this.popupBlocked(this.closeAnnouncement(this.state.announcements[i]))}>
                <NewWindow name={'Announcement'} onUnload={this.closeAnnouncement(this.state.announcements[i])} onBlock={this.popupBlocked(this.closeAnnouncement(this.state.announcements[i]))} features={this.state.announcementMessagefeatureSize} center={'screen'} title={'Announcement'}>
                    <AnnouncementMessage
                        announcement={this.state.announcements[i]}
                    />
                </NewWindow>
            </ErrorBoundary>);
        /*
        announcement = <NewWindow name={'Announcement'} onUnload={this.closeAnnouncement(this.state.announcements[i])} features={this.state.announcementMessagefeatureSize} center={'screen'} title={'Announcement'}>
            <AnnouncementMessage
                announcement={this.state.announcements[i]}
            />
        </NewWindow>;
        */
    }

    // OnCallSchedule on hold
    if (false) {
      onCallSchedule = <OnCallScheduleList callbackFromParent={this.handleCloseMainMenuCallback} />;
    }
    // var win = document.defaultView || document.parentWindow;
    // console.log("win", win);
    return (
        <div>
        {announcements}
        <AppBar position="static">
          <Toolbar style={{ padding: '0px', width: '200px' }}>
            <Grid container item justifyContent="flex-start" spacing={0}>
              <Grid item xs={6}>
                <UserInfo />
              </Grid>
            <Grid container item xs={6} justifyContent="flex-end" style={{}}>
                <div>
                  <IconButton
                    color="inherit"
                    aria-label="Menu"
                    aria-owns={anchorEl ? 'simple-menu' : undefined}
                    aria-haspopup="true"
                    onClick={this.handleClickMainMenu}
                  >
                    <Tooltip
                      placement="bottom"
                      enterDelay={500}
                      title={
                        <React.Fragment>
                          <h6>
                            Main Menu
                          </h6>
                        </React.Fragment>
                      }
                    >
                    <MenuIcon style={{ fontSize: '2.5rem' }} />
                    </Tooltip>
                  </IconButton>
                  <Menu
                    id="simple-menu1"
                    anchorEl={anchorEl}
                    open={Boolean(anchorEl)}
                    onClose={this.handleCloseMainMenu}
                    MenuListProps={{ style: { padding: '0px' } }}
                    //disableAutoFocusItem={true}
                    //autoFocus={false}
                  >
                    <Profile callbackFromParent={this.handleCloseMainMenuCallback} />
                    {onCallSchedule}
                    <MenuItem onClick={this.handleShowBulletin} style={{ padding: '5px 10px', fontSize: '12px', minHeight: '25px' }}><div style={{ color: "white" }}>&bull;</div> View Bulletin</MenuItem>
                    {userManagerMenuItem}
                    {groupManagerMenuItem}
                    {quoteManagerMenuItem}
                    {announcementMenuItem}
                    {notificationsMenuItem}
                    <MenuItem onClick={this.handleClickLogout} style={{ padding: '5px 10px', fontSize: '12px', minHeight: '25px' }}><div style={{ color: "white" }}>&bull;</div> Logout</MenuItem>
                  </Menu>
                </div>
                {bulletin}
                {userManager}
                {groupManager}
                {quoteManager}
                {announcement}
                {/*{announcements}
                 */}
                <PreferencesDialog
                    open={this.state.preferencesOpen}
                    preferences={this.props.preferences}
                    permission={this.state.notificationPermission}
                    onSave={this.savePreferences}
                    onRequestPermission={this.requestNotificationPermission}
                    onTest={this.handleTestNotification}
                    onClose={this.closePreferences}
                    onExited={this.restoreFocusAfterPreferences} />
                <NotificationsHelpDialog
                  open={this.state.notificationsBlockedOpen}
                  onDismiss={this.dismissNotificationsHelp} />
                <PopupBlockedDialog
                  open={this.state.popupsBlocked}
                  what={'a TeamX window'}
                  onDismiss={this.dismissPopupNotice} />
              </Grid>
            </Grid>
          </Toolbar>
        </AppBar>
      </div>
    );
  }
}

const mapStateToProps = state => ({
  //currentUser: state.reducer.currentUser
    profile: state.profile, 
    hub: state.hub,
    preferences: state.preferences,
    preferencesLoaded: state.preferencesLoaded === true
})

const mapDispatchToProps = dispatch => ({
    //getProfileFetch: () => dispatch(getProfileFetch()),
    logoutUser: () => dispatch(logoutUser()),
    updateProfile: user => dispatch(getProfileFetch['UPDATE_PROFILE'](user)),
    setChatDisplay: shouldDisplay => dispatch(windowActions['SET_CHAT_DISPLAY'](shouldDisplay)),
    //updateLastSeen: () => dispatch(userActions['UPDATE_LAST_SEEN']()),
    updateLastSeen: (updateStamp) => dispatch(userActions['UPDATE_LAST_SEEN'](updateStamp)),
    updateStamp: () => dispatch(userActions['UPDATE_STAMP']()),
    updateBulletin: shouldDisplay => dispatch(windowActions['SET_BULLETIN'](shouldDisplay)),
    savePreferences: items => dispatch(preferenceActions['SAVE_PREFERENCES'](items)),
    setIconFlash: shouldTurnFlashOn => dispatch(windowActions['SET_ICON_FLASH'](shouldTurnFlashOn)),
})

export default connect(mapStateToProps, mapDispatchToProps)(UserHub);


// WEBPACK FOOTER //
// ./src/components/UserHub.js